import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridColumn, DynamicEditorItem } from '../grid-control.model';
import { Observable } from 'rxjs';
import { EILSEQ } from 'constants';
@Pipe({
  name: 'editorDynamicItem'
})
export class EditorDynamicItemPipe implements PipeTransform {
  private previous: Date;
  private previousResults: any[] | Observable<any[]> = [];
  private delay = 200; // Sau khoảng thời gian delay nếu không có thay đổi thì thì mới bắt đầu thực hiện gọi hàm
  async transform(value: any, item: GridItem, editor: DynamicEditorItem) {
    this.previous = new Date();
    await new Promise(resolve => setTimeout(resolve, this.delay));
    const now = new Date();
    const dif = now.getTime() - this.previous.getTime();
    if (dif < this.delay) {
      return this.previousResults;
    }
    if (editor.type === 'default') {
      return editor.items;
    } else if (editor.type === 'dependent') {
      const results = editor.items?.(item);
      if (!results) {
        this.previousResults = [];
        return this.previousResults;
      }
      if (results instanceof Promise) {
        this.previousResults = await results;
        return this.previousResults;
      }
      this.previousResults = results;
      return results;
    }
    this.previousResults = [];
    return this.previousResults;
  }
}
